import path from 'path';
import { mkdir } from 'node:fs/promises';
import { createWriteStream } from 'fs';
import Debug from '../../helpers/debug.js';
import ora from 'ora';
import Table from 'cli-table';
import AWS from 'aws-sdk';
import descriptions from '../../helpers/descriptions.js';
import { pr, pp, cl, themed, printJSON } from '../../helpers/print.js';
import { genCredentialsOnClientApi } from '../../helpers/api.js';
import eachSeries from 'async/eachSeries.js';
const debug = Debug('commands:jobs:download');

const command = 'download <jobroot>';

const desc = 'Download Job files';

const builder = async (yargs) => {
  debug('builder', command);

  return yargs.option('downloadTo', descriptions.options['downloadTo'].config);
  // .option('jobroot', descriptions.options['jobroot'].config)
  // .demandOption('jobroot', descriptions.options['jobroot'].demandText)
};

const handler = async (argv) => {
  debug('handler', command, argv);

  const { hg, json, apikey, env, jobroot, downloadTo } = argv;
  const { clientApiBaseUri } = hg;

  let message;
  let spinner = ora();
  try {
    // 1. get STS credentials
    message = themed(`Verifying user and authorizing`);
    !json && spinner.start(themed(`In progress: ${message}...`, 'secondary'));
    const { accessKeyId, secretAccessKey, sessionToken } = await genCredentialsOnClientApi({
      debug,
      baseUri: clientApiBaseUri,
      task: 'job-download',
      env,
      apikey,
      jobroot,
    });
    // get data from AWS bucket
    const s3 = new AWS.S3({
      accessKeyId,
      secretAccessKey,
      sessionToken,
    });
    !json && spinner.succeed(themed(`Finished: ${message}.`, 'secondary'));

    // 2. get list of available files
    message = themed(`Scanning for downloadable files`);
    !json && spinner.start(themed(`In progress: ${message}...`, 'secondary'));
    const params = {
      Bucket: env,
      Prefix: jobroot,
    };
    const { Contents: filesList } = await s3.listObjectsV2(params).promise();
    debug('res', filesList);
    if (!filesList || filesList.length === 0) {
      if (json) {
        printJSON({ status: 'error', error: 'Nothing to download!' });
      } else {
        spinner.fail(themed(`Error: ${message}.`, 'secondary'));
        pr(themed(`Message: ${themed('Nothing to download!')}`, 'secondary'));
      }
      return;
    }
    !json && spinner.succeed(themed(`Finished: ${message}.`, 'secondary'));

    if (!json) {
      // print remote files
      const table = new Table({ head: ['File', 'Size', 'LastModified'] });
      filesList.forEach((item) => {
        const subPath = item.Key.substring(jobroot.length + 1);
        // const details = { LastModified: item.LastModified, Size: item.Size };
        table.push([subPath, item.Size, item.LastModified.toLocaleString('en-US')]); //  JSON.stringify(details, undefined, 2)]);
      });
      console.log(table.toString());
    }

    // 3. download job files one-by-one
    const localRoot = path.resolve(process.cwd(), downloadTo, path.basename(jobroot));
    await eachSeries(
      // Filter out tap/target config files
      filesList.filter(({ Key }) => {
        // Filter out all *-config.json files in the root of "jobroo"
        const regex = new RegExp(`${jobroot}/([^\/]+)-config\.json`);
        return !regex.test(Key);
      }),
      async (item) => {
        message = themed(`Downloading file: ${themed(item.Key, 'info')}`);
        !json && spinner.start(themed(`In progress: ${message}...`, 'secondary'));
        const file = path.resolve(localRoot, item.Key.substring(jobroot.length + 1));
        debug('file', file);

        // ensure destination folder exists
        await mkdir(path.dirname(file), { recursive: true });
        // download s3 object into destination folder
        const fileStream = s3.getObject({ Bucket: env, Key: item.Key }).createReadStream();
        const writableStream = createWriteStream(file, { flags: 'w' });
        fileStream.pipe(writableStream);

        !json && spinner.succeed(themed(`Finished: ${message}.`, 'secondary'));
      }
    );

    // print final success message
    if (json) {
      printJSON({ status: 'success', downloadedFiles: filesList.map(({ Key }) => Key) });
    } else {
      message = themed(`Downloading job files.`);
      spinner.succeed(themed(`Finished: ${message}`, 'secondary'));
    }
  } catch (err) {
    if (json) {
      printJSON({ status: 'error', error: err });
    } else {
      spinner.fail(themed(`Error: ${message}.`, 'secondary'));
      pr(themed(`Message: ${themed(err.message)}`, 'secondary'));
      debug(err);
      if (err && err.response && err.response.data) {
        debug('response', err.response.data);
      }
    }
    process.exit(1)
  }
};

export { command, desc, builder, handler };
